module.exports = __webpack_public_path__ + "files/5ea0b84105fd42950b9f9c1a68ad4c8c.png";